import * as ScheduleVisit from '../VisitTypes/index.js';

/** Notes приходят JSON-строкой — парсим как JSON, а не регулярками по запятым */
export function parseNotes(raw) {
    let n = {};
    try { n = JSON.parse(raw || '{}') || {}; } catch (e) { n = {}; }

    const comeFrom = (n.doctor || n.manager) ? 'салон' : (n.ref || '');
    return {
        comment: n.comment ? String(n.comment).replaceAll('|', '<br>') : '',
        visit: n.visit !== undefined ? (ScheduleVisit.getVisitTypeTitle(n.visit) || n.visit) : '',
        comeFrom,
        manager: n.manager,
        selfAppointment: parseInt(n.selfAppointment, 10) || 0,
    };
}

/** Reason вида "<что-то>: Имя Фамилия +7XXXXXXXXXX" */
export function parseClientFromReason(reason = '') {
    const parts = String(reason).split(': ').slice(1).join(': ').split(' ');
    const phone = parts.pop() || '';
    return { name: parts.join(' '), phone };
}

/** Добавляет комментарий в Notes, возвращает новую JSON-строку */
export function appendComment(rawNotes, text, dateStr) {
    const notes = JSON.parse(rawNotes);
    notes.comment = (notes.comment || '') + '|' + dateStr + ' - ' + text;
    return JSON.stringify(notes);
}
